import '../../styles/login.css';
import '../../styles/sk.css';
import '../../styles/register.css';
import {motion as m} from "framer-motion"
import React, {useEffect, useState} from "react";
import { Nav } from "../../components/navComponents"
import { Header } from "../../components/headerComponent"
import Consts from "../../App/Consts";
import { useNavigate } from "react-router-dom";

export default function HomePage() {
    const navigate = useNavigate();
    var profile = sessionStorage['profile']
    var url = JSON.parse(localStorage.getItem(Consts.GROUP_HOME));
    if (url) {
        if (url[profile] === undefined) {
            window.location.href = '/login'
        }
    }
    React.useEffect(() => {
        if (sessionStorage['isLogged'] === undefined || sessionStorage['isLogged'] !== 'yes'){
            navigate('/login')
        }
    },[])

    return (
        <>
            <m.div className={"wrapper"}>
                <Nav />
                <div id={"page"}>
                    <Header />
                    <div id="content">
                        Bienvenue
                    </div>
                </div>

            </m.div>
        </>
    );
}






